"use client";

import { LifePlanForm } from "./components/life-plan-form";
import { useI18n } from "@/lib/i18n/hook";

export default function LifePlanPage() {
  const { t } = useI18n();
  return (
    <div className="px-4 md:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold mb-6">{t("lifePlan.title")}</h1>
      <LifePlanForm />
    </div>
  );
}
